<div class="form-field-wrapper-toggle" [hidden]="frmGroup.get(configData.name)['hidden']" [formGroup]="frmGroup" 
    [class.disabled]="disabled || frmGroup.get(configData.name).disabled || this.configData['disabled']">
    <label class="dhl-toggle-group-label">{{configData.label}}<span *ngIf="configData.required">*</span></label>
    <mat-button-toggle-group class="btn-group" [(ngModel)]="checkedBtnValue" [ngModelOptions]="{standalone: true}" name="{{configData.name}}">
        <mat-button-toggle class="dhl-toggle-group-value" *ngFor="let option of configData.options;" 
        [value]="option.value" (click)="onToggleButtonGroupChange($event, option);"
        [checked]="option.value == checkedBtnValue">{{option.displayValue}}</mat-button-toggle>
    </mat-button-toggle-group>
</div>
